import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { ERROR_MSG, FAMILY_DETAILS, SEARCH, SELECTED_MEMBER, STOP_FAM_API_CALL, } from "@frameworks/web/redux/interfaces/Reports/iFamilyTagging";
import { EFamilyPersonRole } from "@domains/entities/Reports/Familytagging/MyFamiliesResponsEntity";
const initState = {
    familyDetails: {
        myFamilies: {
            0: {
                members: [],
                myRole: EFamilyPersonRole.MEMBER,
                familyName: "",
                familyIdx: 0,
            },
        },
        myAccCode: "",
        UserIsManagerInMinOneFamily: false,
        UserIsManagerOfFamilyId: "",
    },
    selectedMember: {
        head: "",
        memberName: "",
        accCode: "",
        permission: "",
        role: "",
        familyIdx: 0,
    },
    stopFamilyAPiCall: false,
    search: "",
    loader: false,
    message: {
        msg: null,
        show: false,
        icon: null,
    },
};
const FamilyDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case FAMILY_DETAILS:
            return Object.assign(Object.assign({}, state), { familyDetails: action.payload.familyDetails });
        case SELECTED_MEMBER:
            return Object.assign(Object.assign({}, state), { selectedMember: action.payload.selectedMember });
        case STOP_FAM_API_CALL:
            return Object.assign(Object.assign({}, state), { stopFamilyAPiCall: action.payload.stopFamilyAPiCall });
        case SEARCH:
            return Object.assign(Object.assign({}, state), { search: action.payload.search });
        case ERROR_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: FamilyDetailsReducer,
    commonData: commonOnePlatFormReducer,
});
